import React from "react"

const PlusCircleIcon = ({ style }) => (
  <svg viewBox="0 0 20 20" style={style}>
    <g fill="none" fillRule="evenodd" strokeWidth="1.75">
      <circle cx="10" cy="10" r="9.125" stroke="currentColor" />
      <g stroke="currentColor">
        <path d="m10 6v8" />
        <path d="m6 10h8.0622577" />
      </g>
    </g>
  </svg>
)

export default PlusCircleIcon



// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/PlusCircleIcon.jsx